import UserFpuRole from "@app/Interface/UserFpuRoles";
import UserInterface from "@app/Interface/UserInterface";
import UserViewPermissionsInterface from "@app/Interface/UserViewPermissionInterface";
import ProducerInterface from "@app/Interface/ProducerInterface";
import ProducerModel from "./ProducerModel";
import UserChartNotificationSettingsInterface from "@app/Interface/UserChartNotificationSettingsInterface";
import QcSmartNotificationSettingsInterface from "@app/Interface/QcSmartNotificationSettingsInterface";

export default class UserModel implements UserInterface {

    public iri: string;
    public id: number;
    public email: string;
    public username: string;
    public nickname: string;
    public firstName: string;
    public lastName: string;
    public contactName: string;
    public phoneNumber: string;
    public cellNumber: string;
    public address: string;
    public address2: string;
    public city: string;
    public state: string;
    public zip: string;
    public defaultFpuId: number;
    public currentFpuId: number;
    public currentFpu: ProducerInterface;
    public systemRoles: number[] | boolean;
    public fpuRoles: UserFpuRole[] | boolean;
    public viewPermissions: UserViewPermissionsInterface;
    public enableTwoFactor: boolean;
    public twoFactorType: string;
    public twoFactorEmailAddress: string;
    public twoFactorPhoneNumber: string;
    public isMember: boolean;
    public confirmed: boolean;
    public enableNotifications: boolean;
    public sendEmailNotifications: boolean;
    public notificationEmailAddress: string;
    public sendSmsNotifications: boolean;
    public notificationPhoneNumber: string;
    public fpuChartNotificationSettings: UserChartNotificationSettingsInterface[] | boolean;
    public qcSmartNotificationSettings: boolean | QcSmartNotificationSettingsInterface[];

    constructor() {
        this.iri = "";
        this.id = 0;
        this.email = "";
        this.username = "";
        this.nickname = "";
        this.firstName = "";
        this.lastName = "";
        this.contactName = "";
        this.phoneNumber = "";
        this.cellNumber = "";
        this.address = "";
        this.address2 = "";
        this.city = "";
        this.state = "";
        this.zip = "";
        this.defaultFpuId = 0;
        this.currentFpuId = 0;
        this.currentFpu = new ProducerModel();
        this.systemRoles = [];
        this.fpuRoles = false;
        this.viewPermissions = JSON.parse("{}");
        this.enableTwoFactor = false;
        this.twoFactorType = "email";
        this.twoFactorEmailAddress = "";
        this.twoFactorPhoneNumber = "";
        this.isMember = false;
        this.confirmed = false;
        this.enableNotifications = false;
        this.sendEmailNotifications = false;
        this.notificationEmailAddress = "";
        this.sendSmsNotifications = false;
        this.notificationPhoneNumber = "";
        this.fpuChartNotificationSettings = false;
        this.qcSmartNotificationSettings = false;
    }
    
}